import { Layout } from 'antd'
import { useEffect, useState } from 'react'
import HeaderBar from '../../components/portal/ProfileHeader'
import ProfileMain from '../../components/portal/ProfileMain'
import FooterBar from '../../components/portal/FooterBar'
import './index.css'
import { isAuthenticated } from '../../utils/session'
import { useNavigate } from "react-router-dom";

const { Header, Content, Footer } = Layout

const Index = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!isAuthenticated()) {
            navigate("/");
        }
    }, []);
    // 设置Sider的minHeight可以使左右自适应对齐
    const theme = 'light'
    return (
        <div id='page'>
            <Layout>
                <Layout>
                    <Header style={{ background: '#fff', padding: '0 16px', height: '54px' }}>
                        <HeaderBar />
                    </Header>
                    <Content style={{ background: '#fff', borderTop: '#eee 1px solid' }}>
                        <ProfileMain />
                    </Content>
                    <Footer style={{ textAlign: 'center' }}>
                        <FooterBar />
                    </Footer>
                </Layout>
            </Layout>
        </div>
    );
}

export default Index